import { useMutation } from '@tanstack/react-query';

import { updateNotificationConsentMutation } from '@/api/booking/updateNotificationConsentMutation';

import type { UseUpdateNotificationConsentMutationOptions } from './types';

export const useUpdateNotificationConsentMutation = (
  options?: UseUpdateNotificationConsentMutationOptions,
) => useMutation({ ...updateNotificationConsentMutation(), ...options });
